import { ReturnTypeEnum } from "@redotech/redo-model/return";
import * as z from "zod/v4";

export const deleteReturnViewFolder = {
  name: "deleteReturnViewFolder" as const,
  input: z.object({ folderId: z.string(), type: z.enum(ReturnTypeEnum) }),
  output: z.object({}),
};
